import React, { useEffect, useMemo, useRef, useState } from "react";
import Layout from "../components/Layout";
import apiFetch from "../utils/apiFetch";
import SchemeModal from "../components/schemeModal/SchemeModal";

const CHECK_ITEMS = [
  ["foundation_cond", "Tayanch fundamenti holati"],
  ["foundation_nuts_tight", "Tayanch fundamentidagi gaykalar to‘liq qotirilganligi"],
  ["base_washout", "Tayanch ostini suv yuvish, ochilib qolish holati"],
  ["soil_protect_obval", "Tayanch osti, fundamentlari tuproq bilan himoyalanganligi; (obvalovka)"],
  ["earthing_kz_cond", "Tayanch yerlagichlari holati(KZ)"],
  ["concrete_base_protect", "J/B tayanch holati, ostki qismi tuproq bilan himoyalanganligi"],
  ["pole_tilt", "Tayanchni qiyshaygan, og‘ishma holati"],
  ["dispatcher_marks", "Dispetcherlik yozuvlari, nomlanishi  mavjudligi"],
  ["angle_iron_cond", "Tayanch ugolniklari holati"],
  ["nuts_welded", "Tayanch gaykalarining payvandlanganligi"],
  ["bolts_thread_punched", "Tayanchlardagi boltlarning rezbalari kerno qilinganligi"],
  ["angle_iron_welded", "Tayanchlardagi ugolniklarni bir-biriga payvandlanganligi (o‘g‘irlikni oldini olish)"],
  ["factory_welds_cond", "Ishlab chiqaruvchi tomonidan payvandlangan choklarining holati (korruziyaga uchrashi, yemirilganligi....)"],
  ["leg_fit_to_found", "Metall tayanch oyog‘ining fundament bilan oralig‘i jipsligi (bo‘shlig‘i)"],
  ["guy_anbolts_cond", "Tayanch tortqichlari va AN boltlarini holati"],
  ["cotter_pins", "Shplintlar mavjudligi"],
  ["insulators_cond", "Izolyatorlar holati va ularning to‘g‘riligi, og‘ishma holati"],
  ["conductors_cond", "Simlarni holati"],
  ["shunt_cond", "Shunt holati"],
  ["sas_present", "Shleyflardagi hamda tayanchlar oralig‘ida SASlar mavjudligi"],
  ["thermovision_temp", "Boltli va pressli birikmalardagi teplovizor nazoratida harorat ko‘rsatgichi"],
  ["temp_sas_c", "САС (С°)"],
  ["temp_nas_c", "НАС (С°)"],
  ["pa_clamps_cond", "Boltli birikmalar (PA qisqichlar) holati"],
  ["thermoweld_present", "Termopayka mavjudligi"],
  ["damper_gvn_cond", "Simdagi so‘ndirg‘ich holati; (GVN)"],
  ["spacers_cond", "Rasporkalar holati"],
  ["gzt_present", "Chaqmoqqa qarshi tros (GZT) mavjudligi"],
  ["gzt_cond", "Chaqmoqqa qarshi tros holati"],
  ["spark_gap_cond", "Uchqun oraliq holati; (Искровой промежуток)"],
  ["gzt_earthing_cond", "Chaqmoqqa qarshi tros yerlanganlik holati"],
  ["vols_cond", "Optik tolali aloqa tarmog'i (VOLS) holati"],
  ["corridor_trees", "Muhofaza hududida daraxtlar mavjudligi"],
  ["corridor_reeds", "Muhofaza hududida qamish"],
  ["corridor_wheat", "Muhofaza hududida bug‘doy maydonlari mavjudligi"],
  ["corridor_buildings", "Muhofaza hududda bino, inshoatlar borligi"],
  ["clearance_ok", "Sim bilan yer, daraxt, bino orasidagi masofa holati"],
  ["bird_guard_qqt", "QQT (qushlarga qarshi to'siq) mavjudligi"],
  ["cross_road", "Yo'l bilan kesishmalar mavjudligi"],
  ["cross_powerline", "Elektr tarmog'i bilan kesishmalar mavjudligi"],
  ["cross_river", "Daryo va hokazo bilan kesishmalar mavjudligi"],
  ["winter_ice", "Qish mavsumida sim, trosdagi muzlamalar mavjudligi"],
];

const CHECK_KEYS = CHECK_ITEMS.map(([k]) => k);
const LAST_CHECKUPS_LIMIT = 200;

const DIRECTUS_URL =
  process.env.REACT_APP_DIRECTUS_URL || "https://map.uzbekistonmet.uz";

function normalizeList(json) {
  if (Array.isArray(json)) return json;
  if (Array.isArray(json?.data)) return json.data;
  if (Array.isArray(json?.items)) return json.items;
  if (Array.isArray(json?.rows)) return json.rows;
  return [];
}

function fmtDate(ts) {
  if (!ts) return "—";
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("uz-UZ", {
    timeZone: "Asia/Tashkent",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}

function statusText(s) {
  const v = String(s || "").toLowerCase();
  if (v === "verified") return "Тасдиқланди ✓";
  if (v === "failed") return "Мувофиқ эмас ✕";
  if (v === "pending") return "Текширилмаган ✕";
  if (v === "skipped_offline") return "Офлайн ўтказилган";
  return v || "—";
}

function reasonText(r) {
  if (!r) return "—";
  const v = String(r).toLowerCase();
  if (v === "accuracy_bad") return "GPS аниқлиги паст";
  if (v === "too_far") return "таяначдан узоқ";
  if (v === "no_gps") return "геолокация йўқ";
  if (v === "no_pole_coords") return "таянач координаталари йўқ";
  if (v === "verify_api_error") return "текширув хизмати хатоси";
  return String(r);
}

function parseNegReasons(x) {
  if (!x) return {};
  if (typeof x === "object") return x;
  try {
    return JSON.parse(x);
  } catch {
    return {};
  }
}

function toInt(v) {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(String(v).replace(",", "."));
  if (!Number.isFinite(n)) return null;
  return Math.round(n); // только целые
}

function extractPhotos(checkup) {
  // самый частый кейс как в авариях: checkup.files = [{ directus_files_id: "uuid" | {id} }, ...]
  const files = Array.isArray(checkup?.files) ? checkup.files : [];

  return files
    .map((f) => {
      const raw = f?.directus_files_id ?? f?.file_id ?? f; // подстраховка
      const id = typeof raw === "string" ? raw : raw?.id;
      return id ? { id } : null;
    })
    .filter(Boolean);
}

// простая лимитированная параллельность, чтобы не DDOS-ить сервер
async function mapLimit(list, limit, mapper) {
  const res = new Array(list.length);
  let i = 0;
  const workers = new Array(Math.min(limit, list.length)).fill(0).map(async () => {
    while (i < list.length) {
      const idx = i++;
      res[idx] = await mapper(list[idx], idx);
    }
  });
  await Promise.all(workers);
  return res;
}

function countNoNa(checkup) {
  if (!checkup) return { no: 0, na: 0 };
  let no = 0;
  let na = 0;
  for (const k of CHECK_KEYS) {
    const v = String(checkup?.[k] ?? "").toLowerCase();
    if (v === "no") no++;
    if (v === "na") na++;
  }
  return { no, na };
}

function createEmptyLastMap(poles) {
  const next = {};
  for (const p of poles) {
    if (p?.id != null) next[p.id] = null;
  }
  return next;
}

function buildLastMap(poles, items) {
  const next = createEmptyLastMap(poles);
  for (const item of items || []) {
    if (item?.pole_id != null && Object.prototype.hasOwnProperty.call(next, item.pole_id)) {
      next[item.pole_id] = item;
    }
  }
  return next;
}

async function fetchLastCheckupsBatch(networkId, poles) {
  const poleIds = poles
    .map((p) => Number(p?.id))
    .filter((id) => Number.isInteger(id) && id > 0);

  if (poleIds.length === 0) return {};

  const params = new URLSearchParams({
    network_id: String(networkId),
    limit: String(poleIds.length),
  });
  params.set("pole_ids", poleIds.join(","));

  const res = await apiFetch(`/api/pole-checkups/last-by-network?${params.toString()}`, {
    cache: "no-store",
  });

  if (res.status === 404 || res.status === 501) {
    const err = new Error("last-by-network unavailable");
    err.batchUnavailable = true;
    throw err;
  }
  if (!res.ok) {
    const err = new Error("last-by-network failed");
    err.status = res.status;
    throw err;
  }

  const data = await res.json();
  const items = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : [];
  return buildLastMap(poles, items);
}

async function fetchLastCheckupsFallback(poles) {
  const pairs = await mapLimit(poles, 10, async (p) => {
    try {
      const r = await apiFetch(`/api/pole-checkups/last?pole_id=${p.id}`, { cache: "no-store" });
      if (!r.ok) return [p.id, null];
      const item = await r.json();
      return [p.id, item || null];
    } catch {
      return [p.id, null];
    }
  });

  const next = {};
  for (const [id, item] of pairs) next[id] = item;
  return next;
}

export default function CheckupsPage() {
  const [tab, setTab] = useState("last"); // last | suspicious

  const [networks, setNetworks] = useState([]);
  const [networkSearch, setNetworkSearch] = useState("");
  const [selectedNetwork, setSelectedNetwork] = useState(null);

  const [poles, setPoles] = useState([]);
  const [polesLoading, setPolesLoading] = useState(false);

  const [poleFilter, setPoleFilter] = useState("");
  const [onlyIssues, setOnlyIssues] = useState(false);

  // last checkups per pole
  const [lastMap, setLastMap] = useState({}); // poleId -> checkup|null
  const [lastLoading, setLastLoading] = useState(false);

  // selected pole + history
  const [selectedPole, setSelectedPole] = useState(null);
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);

  // detail modal-ish (inline)
  const [selectedCheckup, setSelectedCheckup] = useState(null);

  // suspicious
  const [susStatus, setSusStatus] = useState(""); // "", failed, pending, skipped_offline
  const [susItems, setSusItems] = useState([]);
  const [susLoading, setSusLoading] = useState(false);

  const [error, setError] = useState("");

  const [photosOpen, setPhotosOpen] = useState(false);
  const [photosIndex, setPhotosIndex] = useState(0);
  const [photosItems, setPhotosItems] = useState([]);
  const loadPolesRequestIdRef = useRef(0);

  useEffect(() => {
    return () => {
      loadPolesRequestIdRef.current += 1;
    };
  }, []);

  const openPhotosModal = (photos, startIndex = 0) => {
    const items = (photos || []).map((p, i) => {
      const id = p?.id || p;
      return {
        id,
        title: `Фото ${i + 1}`,
        thumb: `${DIRECTUS_URL}/assets/${id}?width=480&quality=60&fit=cover`,
        full: `${DIRECTUS_URL}/assets/${id}`,
      };
    });

    setPhotosItems(items);
    setPhotosIndex(startIndex);
    setPhotosOpen(true);
  };

  // load networks
  useEffect(() => {
    (async () => {
      try {
        const res = await apiFetch("/api/network", { cache: "no-store" });
        const json = await res.json();
        setNetworks(Array.isArray(json) ? json : []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const filteredNetworks = useMemo(() => {
    const q = networkSearch.trim().toLowerCase();
    if (q.length < 2) return [];
    return networks
      .filter((n) => {
        const name = String(n?.name || n?.slug || "").toLowerCase();
        const city = String(n?.city?.name || "").toLowerCase();
        return name.includes(q) || city.includes(q);
      })
      .slice(0, 25);
  }, [networks, networkSearch]);

  const filteredPoles = useMemo(() => {
    const q = poleFilter.trim().toLowerCase();
    const list = poles.filter((p) => {
      const name = String(p?.name || "").toLowerCase();
      if (!q) return true;
      return name.includes(q);
    });

    if (!onlyIssues) return list;

    return list.filter((p) => {
      const last = lastMap[p.id];
      const { no } = countNoNa(last);
      return no > 0;
    });
  }, [poles, poleFilter, onlyIssues, lastMap]);

  async function loadPolesForNetwork(network) {
    const requestId = loadPolesRequestIdRef.current + 1;
    loadPolesRequestIdRef.current = requestId;
    const isCurrentRequest = () => loadPolesRequestIdRef.current === requestId;

    setError("");
    setSelectedPole(null);
    setHistory([]);
    setSelectedCheckup(null);

    setPoles([]);
    setLastMap({});

    if (!network?.id) return;

    setPolesLoading(true);
    try {
      const res = await apiFetch(`/api/poles-lite?network_id=${network.id}`, { cache: "no-store" });
      if (!res.ok) {
        const t = await res.text().catch(() => "");
        throw new Error(t || "poles-lite failed");
      }
      const json = await res.json();
      const list = normalizeList(json);
      if (!isCurrentRequest()) return;

      setPoles(list);
      setPolesLoading(false);

      setLastLoading(true);
      const slice = list.slice(0, LAST_CHECKUPS_LIMIT);
      let next = createEmptyLastMap(slice);
      try {
        next = await fetchLastCheckupsBatch(network.id, slice);
      } catch (batchError) {
        if (!batchError?.batchUnavailable) {
          throw batchError;
        }
        next = await fetchLastCheckupsFallback(slice);
      }

      if (!isCurrentRequest()) return;
      setLastMap(next);
    } catch (e) {
      if (!isCurrentRequest()) return;
      console.error(e);
      setError(
        e?.batchUnavailable || e?.message === "last-by-network failed"
          ? "Охирги кўрикларни юклаб бўлмади."
          : "Таянчларни юклаб бўлмади."
      );
    } finally {
      if (isCurrentRequest()) {
        setPolesLoading(false);
        setLastLoading(false);
      }
    }
  }

  async function loadHistoryForPole(pole) {
    setSelectedPole(pole);
    setSelectedCheckup(null);
    setHistory([]);
    setHistoryLoading(true);
    setError("");

    try {
      const res = await apiFetch(`/api/poles/${pole.id}/checkups?limit=50&offset=0`, { cache: "no-store" });
      if (!res.ok) {
        const t = await res.text().catch(() => "");
        throw new Error(t || "checkups failed");
      }
      const items = await res.json();
      setHistory(Array.isArray(items) ? items : []);
    } catch (e) {
      console.error(e);
      setError("Кўриклар тарихи юклаб бўлмади (рухсат/серверни текширинг).");
    } finally {
      setHistoryLoading(false);
    }
  }

  async function loadSuspicious() {
    setSusItems([]);
    setSusLoading(true);
    setError("");
    try {
      const q = susStatus ? `?status=${encodeURIComponent(susStatus)}` : "";
      const res = await apiFetch(`/api/pole-checkups/suspicious${q}`, { cache: "no-store" });
      if (!res.ok) {
        const t = await res.text().catch(() => "");
        throw new Error(t || "suspicious failed");
      }
      const items = await res.json();
      setSusItems(Array.isArray(items) ? items : []);
    } catch (e) {
      console.error(e);
      setError("GPS шубҳали кўрикларини юклаб бўлмади (рухсат/серверни текширинг).");
    } finally {
      setSusLoading(false);
    }
  }

  // auto load suspicious when tab active
  useEffect(() => {
    if (tab === "suspicious") loadSuspicious();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, susStatus]);

  const selectedNetworkTitle = selectedNetwork?.name || selectedNetwork?.slug || "—";
  const lastValues = Object.values(lastMap).filter(Boolean);
  const checkedPoleCount = poles.filter((p) => Boolean(lastMap[p.id])).length;
  const issuePoleCount = poles.filter((p) => countNoNa(lastMap[p.id]).no > 0).length;
  const pendingPoleCount = Math.max(0, poles.length - checkedPoleCount);
  const visiblePoleCount = filteredPoles.length;

  return (
    <Layout>
      <div className="container">
        <div className="checkups-page">
          <div className="checkups-page__hero">
            <div className="checkups-page__hero-main">
              <span className="checkups-page__eyebrow">Таянчлар мониторинги</span>
              <h1 className="checkups-page__title">Охирги кўриклар</h1>
              <div className="checkups-page__subtitle">
                {selectedNetwork
                  ? `${selectedNetworkTitle} · ${visiblePoleCount} та кўринади`
                  : "Линияни танланг ва таянчлар бўйича охирги ҳолатни кўринг"}
              </div>
            </div>

            <div className="checkups-page__tabs">
              <button
                type="button"
                className={"checkups-page__tab " + (tab === "last" ? "is-active" : "")}
                onClick={() => setTab("last")}
              >
                Охирги
              </button>
              <button
                type="button"
                className={"checkups-page__tab " + (tab === "suspicious" ? "is-active" : "")}
                onClick={() => setTab("suspicious")}
              >
                GPS шубҳали
              </button>
            </div>
          </div>

          <div className="checkups-page__summary" aria-label="Жорий ҳолат">
            <div className="checkups-page__summary-item">
              <span>Таянчлар</span>
              <strong>{poles.length}</strong>
            </div>
            <div className="checkups-page__summary-item checkups-page__summary-item--ok">
              <span>Кўрилган</span>
              <strong>{checkedPoleCount}</strong>
            </div>
            <div className="checkups-page__summary-item checkups-page__summary-item--bad">
              <span>Муаммоли</span>
              <strong>{issuePoleCount}</strong>
            </div>
            <div className="checkups-page__summary-item">
              <span>Кўрик йўқ</span>
              <strong>{pendingPoleCount}</strong>
            </div>
            <div className="checkups-page__summary-item checkups-page__summary-item--warn">
              <span>GPS шубҳали</span>
              <strong>{tab === "suspicious" ? susItems.length : lastValues.filter((x) => String(x?.verification_status || "").toLowerCase() === "failed").length}</strong>
            </div>
          </div>

          {/* Filters */}
          <div className="checkups-page__filters">
            {tab === "last" && (
              <>
                <div className="checkups-page__filter-row">
                  <div className="checkups-page__search">
                    <input
                      className="checkups-page__search-input"
                      placeholder="Линия номини киритинг (камида 2 та белги)..."
                      value={networkSearch}
                      onChange={(e) => setNetworkSearch(e.target.value)}
                    />
                    {networkSearch.trim().length >= 2 && (
                      <div className="checkups-page__dropdown">
                        {filteredNetworks.length === 0 ? (
                          <div className="checkups-page__dropdown-empty">Ҳеч нарса топилмади</div>
                        ) : (
                          filteredNetworks.map((n) => (
                            <button
                              key={n.id}
                              type="button"
                              className="checkups-page__dropdown-item"
                              onClick={async () => {
                                setSelectedNetwork(n);
                                setNetworkSearch("");
                                await loadPolesForNetwork(n);
                              }}
                            >
                              <div className="checkups-page__dropdown-name">{n.name || n.slug || "—"}</div>
                              <div className="checkups-page__dropdown-meta">{n.city?.name || "—"}</div>
                            </button>
                          ))
                        )}
                      </div>
                    )}
                  </div>

                  <div className="checkups-page__right-filters">
                    <input
                      className="checkups-page__pole-filter"
                      placeholder="Таянч номини қидириш..."
                      value={poleFilter}
                      onChange={(e) => setPoleFilter(e.target.value)}
                      disabled={!selectedNetwork}
                    />

                    <button
                      type="button"
                      className={"checkups-page__chip " + (onlyIssues ? "is-on" : "")}
                      onClick={() => setOnlyIssues((x) => !x)}
                      disabled={!selectedNetwork}
                      title="Фақат муаммоли (no) кўрсатиш"
                    >
                      Фақат муаммоли
                    </button>

                    <div className="checkups-page__meta">
                      <span className={"checkups-page__badge " + (polesLoading ? "" : "checkups-page__badge--ok")}>
                        {polesLoading ? "Юкланмоқда..." : `${poles.length} таянч`}
                      </span>
                      <span className={"checkups-page__badge " + (lastLoading ? "" : "checkups-page__badge--warn")}>
                        {lastLoading ? "Кўриклар..." : "Охирги кўрик"}
                      </span>
                    </div>
                  </div>
                </div>

                {selectedNetwork && (
                  <div className="checkups-page__selected">
                    <div className="checkups-page__selected-title">
                      Танланди: <span>{selectedNetwork.name || selectedNetwork.slug || "—"}</span>
                      {selectedNetwork.city?.name ? (
                        <span className="checkups-page__selected-meta"> · {selectedNetwork.city.name}</span>
                      ) : null}
                    </div>
                    <button
                      type="button"
                      className="checkups-page__link"
                      onClick={() => {
                        loadPolesRequestIdRef.current += 1;
                        setSelectedNetwork(null);
                        setPoles([]);
                        setLastMap({});
                        setSelectedPole(null);
                        setHistory([]);
                        setSelectedCheckup(null);
                        setPoleFilter("");
                        setOnlyIssues(false);
                        setPolesLoading(false);
                        setLastLoading(false);
                      }}
                    >
                      Тозалаш
                    </button>
                  </div>
                )}
              </>
            )}

            {tab === "suspicious" && (
              <div className="checkups-page__filter-row">
                <div className="checkups-page__select">
                  <div className="checkups-page__select-label">Статус:</div>
                  <select
                    className="checkups-page__select-input"
                    value={susStatus}
                    onChange={(e) => setSusStatus(e.target.value)}
                  >
                    <option value="">Ҳаммаси</option>
                    <option value="failed">Мувофиқ эмас</option>
                    <option value="pending">Текширилмаган</option>
                    <option value="skipped_offline">Офлайн</option>
                  </select>
                </div>

                <div className="checkups-page__meta">
                  <span className={"checkups-page__badge " + (susLoading ? "" : "checkups-page__badge--warn")}>
                    {susLoading ? "Юкланмоқда..." : `${susItems.length} та`}
                  </span>
                </div>
              </div>
            )}
          </div>

          {error && <div className="checkups-page__alert checkups-page__alert--error">{error}</div>}

          {/* Content */}
          {tab === "last" ? (
            <div className="checkups-page__grid">
              {/* Left: poles list */}
              <div className="checkups-list">
                <div className="checkups-list__head">
                  <div className="checkups-list__head-title">Таянчлар</div>
                  <div className="checkups-list__head-hint">Охирги кўрик</div>
                </div>

                {!selectedNetwork ? (
                  <div className="checkups-list__empty">Аввал линияни танланг.</div>
                ) : (
                  <div className="checkups-list__body">
                    {filteredPoles.map((p) => {
                      const last = lastMap[p.id];
                      const { no, na } = countNoNa(last);
                      const vStatus = last?.verification_status || "—";
                      const badgeClass =
                        String(vStatus).toLowerCase() === "verified"
                          ? "checkups-list__badge checkups-list__badge--ok"
                          : String(vStatus).toLowerCase() === "failed"
                          ? "checkups-list__badge checkups-list__badge--bad"
                          : "checkups-list__badge";

                      return (
                        <button
                          key={p.id}
                          type="button"
                          className={"checkups-list__row " + (selectedPole?.id === p.id ? "is-active" : "")}
                          onClick={() => loadHistoryForPole(p)}
                        >
                          <div className="checkups-list__cell">
                            <div className="checkups-list__pole-name">{p.name || `Таянч #${p.id}`}</div>
                            <div className="checkups-list__meta">
                              Охирги: {last ? fmtDate(last.performed_at || last.date_created) : "Кўрик топилмади"}
                            </div>
                          </div>

                          <div className="checkups-list__cell checkups-list__counts">
                            <span className={"checkups-list__count checkups-list__count--no " + (no > 0 ? "is-on" : "")}>
                              Муаммо {no}
                            </span>
                            {/* <span className={"checkups-list__count checkups-list__count--na " + (na > 0 ? "is-on" : "")}>
                              ⛔ {na}
                            </span> */}
                          </div>

                          <div className="checkups-list__cell">
                            <span className={badgeClass}>{statusText(vStatus)}</span>
                          </div>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Right: history + details */}
              <div className="checkups-side">
                <div className="checkups-side__head">
                  <div className="checkups-side__title">
                    {selectedPole ? (selectedPole.name || `Таянч #${selectedPole.id}`) : "Таянч танланмаган"}
                  </div>
                  {selectedPole && (
                    <div className="checkups-side__subtitle">
                      Кўриклар тарихи
                    </div>
                  )}
                </div>

                {!selectedPole ? (
                  <div className="checkups-side__empty">Чап томондан таянчни танланг.</div>
                ) : historyLoading ? (
                  <div className="checkups-side__loading">Юкланмоқда...</div>
                ) : history.length === 0 ? (
                  <div className="checkups-side__empty">Кўриклар йўқ.</div>
                ) : (
                  <div className="checkups-history">
                    {/* {history.map((h) => {
                      const { no, na } = countNoNa(h);
                      const v = h?.verification_status || "—";
                      const badgeClass =
                        String(v).toLowerCase() === "verified"
                          ? "checkups-history__badge checkups-history__badge--ok"
                          : String(v).toLowerCase() === "failed"
                          ? "checkups-history__badge checkups-history__badge--bad"
                          : "checkups-history__badge";

                      return (
                        <button
                          key={h.id}
                          type="button"
                          className={"checkups-history__row " + (selectedCheckup?.id === h.id ? "is-active" : "")}
                          onClick={() => setSelectedCheckup((prev) => (prev?.id === h.id ? null : h))}
                        >
                          <div className="checkups-history__left">
                            <div className="checkups-history__date">{fmtDate(h.performed_at || h.date_created)}</div>
                            <div className="checkups-history__inspector">
                              {h?.inspector_user
                                ? `${h.inspector_user.name || ""} ${h.inspector_user.lastname || ""}`.trim()
                                : "—"}
                            </div>
                          </div>

                          <div className="checkups-history__right">
                            <div className="checkups-history__summary">
                              <span className={"checkups-history__count checkups-history__count--no " + (no > 0 ? "is-on" : "")}>
                                ⚠ {no}
                              </span>
                              <span className={"checkups-history__count checkups-history__count--na " + (na > 0 ? "is-on" : "")}>
                                ⛔ {na}
                              </span>
                            </div>
                            <span className={badgeClass}>{statusText(v)}</span>
                          </div>
                        </button>
                      );
                    })} */}
                    {history.map((h) => {
                        const { no, na } = countNoNa(h);
                        const v = h?.verification_status || "—";

                        const isOpen = selectedCheckup?.id === h.id;

                        const badgeClass =
                            String(v).toLowerCase() === "verified"
                            ? "checkups-history__badge checkups-history__badge--ok"
                            : String(v).toLowerCase() === "failed"
                            ? "checkups-history__badge checkups-history__badge--bad"
                            : "checkups-history__badge";

                        return (
                            <React.Fragment key={h.id}>
                            <button
                                type="button"
                                className={"checkups-history__row " + (isOpen ? "is-active" : "")}
                                onClick={() => setSelectedCheckup((prev) => (prev?.id === h.id ? null : h))}
                            >
                                <div className="checkups-history__left">
                                <div className="checkups-history__date">{fmtDate(h.performed_at || h.date_created)}</div>
                                <div className="checkups-history__inspector">
                                    {h?.inspector_user
                                    ? `${h.inspector_user.name || ""} ${h.inspector_user.lastname || ""}`.trim()
                                    : "—"}
                                </div>
                                </div>

                                <div className="checkups-history__right">
                                <div className="checkups-history__summary">
                                    <span className={"checkups-history__count checkups-history__count--no " + (no > 0 ? "is-on" : "")}>
                                    Муаммо {no}
                                    </span>
                                    {/* <span className={"checkups-history__count checkups-history__count--na " + (na > 0 ? "is-on" : "")}>
                                    ⛔ {na}
                                    </span> */}
                                </div>
                                <span className={badgeClass}>{statusText(v)}</span>
                                </div>
                            </button>

                            {isOpen && (
                            <div className="checkup-view checkup-view--inline">
                                <div className="checkup-view__head">
                                <div className="checkup-view__title">Кўрик тафсилотлари</div>
                                </div>

                                <div className="checkup-view__grid">
                                <div className="checkup-view__item">
                                    <div className="checkup-view__item-label">Сана</div>
                                    <div className="checkup-view__item-value">{fmtDate(h.performed_at || h.date_created)}</div>
                                </div>

                                <div className="checkup-view__item">
                                    <div className="checkup-view__item-label">Гео статус</div>
                                    {/* <div className="checkup-view__item-value">
                                    {statusText(h.verification_status)} ✓ · Сабаб: {reasonText(h.verification_reason)}
                                    </div> */}
                                    {/* <div className="checkup-view__item-value">
                                      {statusText(h.verification_status)} ✓
                                      {h.verification_reason ? (
                                        <> · Сабаб: {reasonText(h.verification_reason)}</>
                                      ) : null}
                                    </div> */}
                                      <div className="checkup-view__item-value">
                                        {statusText(h.verification_status)}
                                      </div>
                                </div>

                                <div className="checkup-view__item">
                                    <div className="checkup-view__item-label">Масофа</div>
                                    <div className="checkup-view__item-value">
                                    {toInt(h.distance_to_pole_m) !== null ? `${toInt(h.distance_to_pole_m)} м` : "—"}
                                    </div>
                                </div>

                                {/* <div className="checkup-view__item">
                                    <div className="checkup-view__item-label">Аниқлик</div>
                                    <div className="checkup-view__item-value">
                                    {toInt(h.accuracy_m) !== null ? `${toInt(h.accuracy_m)} м` : "—"}
                                    </div>
                                </div> */}

                                {h.verification_reason ? (
                                  <div className="checkup-view__item">
                                    <div className="checkup-view__item-label">Сабаб</div>
                                    <div className="checkup-view__item-value">
                                      {reasonText(h.verification_reason)}
                                    </div>
                                  </div>
                                ) : null}

                                {h.notes ? (
                                    <div className="checkup-view__item checkup-view__item--full">
                                    <div className="checkup-view__item-label">Изоҳ</div>
                                    <div className="checkup-view__item-value">{String(h.notes)}</div>
                                    </div>
                                ) : null}
                                </div>

                                {(() => {
                                  const photos = extractPhotos(h);
                                  if (!photos.length) return null;

                                  return (
                                    <div className="checkup-view__photos" onClick={(e) => e.stopPropagation()}>
                                      {photos.map((p, idx) => (
                                        <button
                                          key={p.id}
                                          type="button"
                                          className="checkup-photo"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            openPhotosModal(photos, idx);
                                          }}
                                          title={`Фото ${idx + 1}`}
                                        >
                                          <img
                                            className="checkup-photo__img"
                                            src={`${DIRECTUS_URL}/assets/${p.id}`}
                                            alt=""
                                            loading="lazy"
                                          />
                                        </button>
                                      ))}
                                    </div>
                                  );
                                })()}

                                <div className="checkup-view__section">
                                <div className="checkup-view__section-title">Кўрик бандлари</div>

                                <div className="checkup-view__list">
                                    {CHECK_ITEMS.map(([key, label]) => {
                                    const v = String(h?.[key] ?? "").toLowerCase();
                                    const reasons = parseNegReasons(h?.negative_reasons);
                                    const r = reasons?.[key];

                                    const icon = v === "yes" ? "✓" : v === "no" ? "⚠" : v === "na" ? "✕" : "—";
                                    const cls =
                                        v === "yes"
                                        ? "checkup-view__status checkup-view__status--yes"
                                        : v === "no"
                                        ? "checkup-view__status checkup-view__status--no"
                                        : v === "na"
                                        ? "checkup-view__status checkup-view__status--na"
                                        : "checkup-view__status";

                                    return (
                                        <div key={key} className="checkup-view__row">
                                        <div className="checkup-view__row-label">{label}</div>
                                        <div className="checkup-view__row-right">
                                            {v === "no" && r ? <span className="checkup-view__reason">{String(r)}</span> : null}
                                            <span className={cls}>{icon}</span>
                                        </div>
                                        </div>
                                    );
                                    })}
                                </div>
                                </div>
                            </div>
                            )}
                            </React.Fragment>
                        );
                        })}
                  </div>
                )}

                {/* {selectedCheckup && (
                  <div className="checkup-view">
                    <div className="checkup-view__head">
                      <div className="checkup-view__title">Кўрик тафсилотлари</div>
                    </div>

                    <div className="checkup-view__grid">
                      <div className="checkup-view__item">
                        <div className="checkup-view__item-label">Сана</div>
                        <div className="checkup-view__item-value">{fmtDate(selectedCheckup.performed_at || selectedCheckup.date_created)}</div>
                      </div>

                      <div className="checkup-view__item">
                        <div className="checkup-view__item-label">Гео статус</div>
                        <div className="checkup-view__item-value">
                          {statusText(selectedCheckup.verification_status)}
                          {" · "}
                          Сабаб: {reasonText(selectedCheckup.verification_reason)}
                        </div>
                      </div>

                      <div className="checkup-view__item">
                        <div className="checkup-view__item-label">Масофа</div>
                        <div className="checkup-view__item-value">
                            {toInt(selectedCheckup.distance_to_pole_m) !== null
                            ? `${toInt(selectedCheckup.distance_to_pole_m)} м`
                            : "—"}
                        </div>
                      </div>

                      <div className="checkup-view__item">
                        <div className="checkup-view__item-label">Аниқлик</div>
                            <div className="checkup-view__item-value">
                                {toInt(selectedCheckup.accuracy_m) !== null
                                ? `${toInt(selectedCheckup.accuracy_m)} м`
                                : "—"}
                            </div>
                      </div>

                      {selectedCheckup.notes ? (
                        <div className="checkup-view__item checkup-view__item--full">
                          <div className="checkup-view__item-label">Изоҳ</div>
                          <div className="checkup-view__item-value">{String(selectedCheckup.notes)}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="checkup-view__section">
                      <div className="checkup-view__section-title">Кўрик бандлари</div>

                      <div className="checkup-view__list">
                        {CHECK_ITEMS.map(([key, label]) => {
                          const v = String(selectedCheckup?.[key] ?? "").toLowerCase();
                          const reasons = parseNegReasons(selectedCheckup?.negative_reasons);
                          const r = reasons?.[key];

                          const icon = v === "yes" ? "✓" : v === "no" ? "⚠" : v === "na" ? "⛔" : "—";
                          const cls =
                            v === "yes"
                              ? "checkup-view__status checkup-view__status--yes"
                              : v === "no"
                              ? "checkup-view__status checkup-view__status--no"
                              : v === "na"
                              ? "checkup-view__status checkup-view__status--na"
                              : "checkup-view__status";

                          return (
                            <div key={key} className="checkup-view__row">
                              <div className="checkup-view__row-label">{label}</div>
                              <div className="checkup-view__row-right">
                                <span className={cls} title={v}>{icon}</span>
                                {v === "no" && r ? (
                                  <span className="checkup-view__reason">{String(r)}</span>
                                ) : null}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          ) : (
            // suspicious tab
            <div className="checkups-suspicious">
              {susLoading ? (
                <div className="checkups-suspicious__loading">Юкланмоқда...</div>
              ) : susItems.length === 0 ? (
                <div className="checkups-suspicious__empty">Ҳеч нарса йўқ.</div>
              ) : (
                <div className="checkups-suspicious__list">
                  {susItems.map((x) => {
                    const poleName = x?.pole?.name || `Таянч #${x?.pole?.id || "—"}`;
                    return (
                      <div key={x.id} className="checkups-suspicious__row">
                        <div className="checkups-suspicious__left">
                          <div className="checkups-suspicious__title">{poleName}</div>
                          <div className="checkups-suspicious__meta">
                            Линия: {x?.pole?.network?.name || "—"} · Шаҳар: {x?.pole?.city?.name || "—"}
                          </div>
                          <div className="checkups-suspicious__meta">
                            Сана: {fmtDate(x.performed_at || x.date_created)} · Инспектор:{" "}
                            {x?.inspector_user
                              ? `${x.inspector_user.name || ""} ${x.inspector_user.lastname || ""}`.trim()
                              : "—"}
                          </div>
                        </div>

                        <div className="checkups-suspicious__right">
                          <span className="checkups-suspicious__badge">
                            {statusText(x.verification_status)}
                          </span>
                          <div className="checkups-suspicious__reason">
                            Сабаб: {reasonText(x.verification_reason)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <SchemeModal
        open={photosOpen}
        items={photosItems}
        index={photosIndex}
        onClose={() => {
          setPhotosOpen(false);
          setPhotosItems([]);
          setPhotosIndex(0);
        }}
        onChangeIndex={setPhotosIndex}
      />
    </Layout>
  );
}
